import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useTypedSelector } from '../hooks';
import { isPhoneVerificationPending } from '../store/action-creators/user';

export const UnAuthorizedRoute = ({ component, redirectPath = '/dashboard', ...rest }: any) => {
  const { user } = useTypedSelector(state => state);
  const allowAccess = !user?.uuid || isPhoneVerificationPending(user);

  const routeComponent = (props: any) =>
    allowAccess ? React.createElement(component, props) : <Redirect to={{ pathname: redirectPath }} />;
  return <Route {...rest} render={routeComponent} />;
};
